import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import { MoreHorizontalRegular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

export const MailFolderItemMenu = ({
  display,
  onClickApplyAll,
  onClickApplySelected,
}: {
  display: boolean;
  onClickApplyAll: () => void;
  onClickApplySelected: () => void;
}) => {
  const { t } = useTranslation();

  if (!display) return null;

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <Button appearance="transparent" icon={<MoreHorizontalRegular />} onClick={(e) => e.stopPropagation()} />
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              onClickApplyAll();
            }}
          >
            {t('folderActions.applyAll')}
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              onClickApplySelected();
            }}
          >
            {t('folderActions.applySelected')}
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
